/* eslint-disable */
//tslint:disable

export interface IActionButtonV2Schema {
  /** Ссылка по которой надо перейти в случае выбора этого варианта ответа **/
  link?: string | null;
  /** Название маркетинговой кампании для аналитики **/
  promoName: string;
  /** Вариант который надо отправить по socket-у **/
  socketPayload?: string | null;
  /** Текст ссылки или текст варианта ответа **/
  text: string;
  /** 
    Тип ответа.
    Если ссылка deeplink, то обязательно должно быть поле link.
    Если вариант ответа который надо вернут по socket, то обязательно должно быть поле socketPayload.
     **/
  type: EType;
}

export enum EType {
  /**  **/
  Deeplink = 'deeplink',
  /**  **/
  Socket = 'socket',
}
